<div class="jit-report-question-boolean"></div>